import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import axiosInstance from "../../../services/API";

export const postToPinboard = createAsyncThunk("postToPinboard", async (data, { rejectWithValue }) => {
    try {
        const response = await axiosInstance.post(`/neighbor_pinboard/create/`, data, {
            headers: {
                'Content-Type': 'multipart/form-data',
            },
        });

        if (response && response.data) {
            return response.data;
        } else {
            throw new Error("Invalid response from server");
        }
    } catch (error) {
        console.error("Error:", error);
        return rejectWithValue(error.response ? error.response.data : error.message);
    }
});

export const getAllPinboard = createAsyncThunk("getAllPinboard", async ({ page = 1 }, { rejectWithValue }) => {
    try {
        const response = await axiosInstance.get(`/neighbor_pinboard/?page=${page}`);
        const result = response.data;
        return result
    }
    catch (error) {
        return rejectWithValue(error.response ? error.response.data : error.message);
        console.error("Error:", error.response.data);
    }
});

export const getLoginUserAllPinboard = createAsyncThunk("getLoginUserAllPinboard", async (page = 1, { rejectWithValue }) => {
    try {
        const response = await axiosInstance.get(`/neighbor_pinboard/pinboard/your-posts/?page=${page}`);
        const result = response.data;
        return { ...result, page };
    }
    catch (error) {
        console.error("Error:", error.response.data);
        return rejectWithValue(error.response ? error.response.data : error.message);
    }
});

export const loadMoreUserPinboard = createAsyncThunk("loadMoreUserPinboard", async (page, { rejectWithValue }) => {
    try {
        const response = await axiosInstance.get(`/neighbor_pinboard/pinboard/your-posts/?page=${page}`);
        const result = response.data;
        return { ...result, page };
    }
    catch (error) {
        console.error("Error:", error.response.data);
        return rejectWithValue(error.response ? error.response.data : error.message);
    }
});

export const getSavedPinboard = createAsyncThunk("getSavedPinboard", async (page = 1, { rejectWithValue }) => {
    try {
        const response = await axiosInstance.get(`neighbor_pinboard/pinboard/saved-posts/?page=${page}`);
        const result = response.data;
        return { ...result, page };
    }
    catch (error) {
        console.error("Error:", error.response.data);
        return rejectWithValue(error.response ? error.response.data : error.message);
    }
});

export const loadMoreSavedPinboard = createAsyncThunk("loadMoreSavedPinboard", async (page, { rejectWithValue }) => {
    try {
        const response = await axiosInstance.get(`neighbor_pinboard/pinboard/saved-posts/?page=${page}`);
        const result = response.data;
        return { ...result, page };
    }
    catch (error) {
        console.error("Error:", error.response.data);
        return rejectWithValue(error.response ? error.response.data : error.message);
    }
});

export const getPinboardById = createAsyncThunk("getPinboardById", async (data) => {
    try {
        const response = await axiosInstance.get(`/neighbor_pinboard/${data}/`);
        const result = response.data;
        return result
    }
    catch (error) {
        console.error("Error:", error.response.data);
    }
});

export const updatePinboardById = createAsyncThunk("updatePinboardById", async (data, { rejectWithValue }) => {
    try {
        const response = await axiosInstance.patch(`/neighbor_pinboard/${data.id}/update/`, data.data, {
            headers: {
                'Content-Type': 'multipart/form-data',
            },
        });

        if (response && response.data) {
            return response.data;
        } else {
            throw new Error("Invalid response from server");
        }
    }
    catch (error) {
        console.error("Error:", error);
        return rejectWithValue(error.response ? error.response.data : error.message);
    }
});

export const deletePinboard = createAsyncThunk("deletePinboard", async (data, { rejectWithValue }) => {
    try {
        const response = await axiosInstance.delete(`/neighbor_pinboard/${data}/delete/`);
        return { id: data, response: response.data };
    }
    catch (error) {
        console.error("Error:", error);
        return rejectWithValue(error.response ? error.response.data : error.message);
    }
});

export const likePinboard = createAsyncThunk("likePinboard", async (data, { rejectWithValue }) => {
    try {
        const response = await axiosInstance.put(`/neighbor_pinboard/${data}/like/`);
        return response.data;
    }
    catch (error) {
        console.error("Error:", error);
        return rejectWithValue(error.response ? error.response.data : error.message);
    }
});

export const savePinboard = createAsyncThunk("savePinboard", async (data, { rejectWithValue }) => {
    try {
        const response = await axiosInstance.post(`/neighbor_pinboard/pinboard/${data}/save/`);
        return response.data;
    }
    catch (error) {
        console.error("Error:", error);
        return rejectWithValue(error.response ? error.response.data : error.message);
    }
});

// export const createpinboardComment = createAsyncThunk("createpinboardComment", async ({ data, pinboardId }, { rejectWithValue }) => {
//     try {
//         const response = await axiosInstance.post(`/neighbor_pinboard/${pinboardId}/comment/`, data)
//         const result = response.data;
//         return result
//     } catch (error) {
//         if (error.response) {
//             // The request was made and the server responded with a status code
//             return rejectWithValue(error.response.data);
//         }
//         else if (error.request) {
//             // The request was made but no response was received
//             return rejectWithValue("No response from server");
//         }
//         else {
//             // Something happened in setting up the request that triggered an Error
//             return rejectWithValue(error.message);
//         }
//     }
// });

// export const updatepinboardComment = createAsyncThunk("updatepinboardComment", async ({ data, commentId },
//     { rejectWithValue }) => {
//     try {
//         const response = await axiosInstance.put(`/neighbor_pinboard/comment/${commentId}/update/`, data)
//         const result = response.data;
//         return result
//     } catch (error) {
//         if (error.response) {
//             // The request was made and the server responded with a status code
//             return rejectWithValue(error.response.data);
//         }
//         else if (error.request) {
//             // The request was made but no response was received

//             return rejectWithValue("No response from server");
//         }
//         else {
//             // Something happened in setting up the request that triggered an Error
//             return rejectWithValue(error.message);
//         }
//     }
// });

// export const deletepinboardComment = createAsyncThunk("deletepinboardComment", async ({ commentId },
//     { rejectWithValue }) => {
//     try {
//         const response = await axiosInstance.delete(`/neighbor_pinboard/comment/${commentId}/delete/`)
//         return commentId
//     } catch (error) {
//         if (error.response) {
//             return rejectWithValue(error.response.data);
//         }
//         else if (error.request) {
//             return rejectWithValue("No response from server");
//         }
//         else {
//             return rejectWithValue(error.message);
//         }
//     }
// });

// export const likePinboardComment = createAsyncThunk("likePinboardComment", async ({ commentId }, { rejectWithValue }) => {
//     try {
//         const response = await axiosInstance.post(`/neighbor_pinboard/comment/${commentId}/like/`);
//         const result = response.data;
//         return result
//     }
//     catch (error) {
//         console.error("Error:", error);
//         return rejectWithValue(error.response ? error.response.data : error.message);
//     }
// });
// export const createpinboardCommentReply = createAsyncThunk("createpinboardCommentReply", async ({ data, commentId }, { rejectWithValue }) => {
//     try {
//         const response = await axiosInstance.post(`/neighbor_pinboard/comment/${commentId}/reply/`, data)
//         const result = response.data;
//         return { result, comment_id: commentId }
//     } catch (error) {
//         if (error.response) {
//             // The request was made and the server responded with a status code
//             return rejectWithValue(error.response.data);
//         }
//         else if (error.request) {
//             // The request was made but no response was received
//             return rejectWithValue("No response from server");
//         }
//         else {
//             // Something happened in setting up the request that triggered an Error
//             return rejectWithValue(error.message);
//         }
//     }
// });
// export const updatepinboardCommentReply = createAsyncThunk("updatepinboardCommentReply", async ({ data, replyId },
//     { rejectWithValue }) => {
//     try {
//         const response = await axiosInstance.patch(`/neighbor_pinboard/reply/${replyId}/update/`, data)
//         const result = response.data;
//         return { data, replyId }
//     } catch (error) {
//         if (error.response) {
//             // The request was made and the server responded with a status code
//             return rejectWithValue(error.response.data);
//         }
//         else if (error.request) {
//             // The request was made but no response was received
//             return rejectWithValue("No response from server");
//         }
//         else {
//             // Something happened in setting up the request that triggered an Error
//             return rejectWithValue(error.message);
//         }
//     }
// });
// export const deletepinboardCommentReply = createAsyncThunk("deletepinboardCommentReply", async ({ replyId },
//     { rejectWithValue }) => {
//     try {
//         const response = await axiosInstance.delete(`/neighbor_pinboard/reply/${replyId}/delete/`)
//         return replyId
//     } catch (error) {
//         if (error.response) {
//             return rejectWithValue(error.response.data);
//         }
//         else if (error.request) {

//             return rejectWithValue("No response from server");
//         }
//         else {
//             return rejectWithValue(error.message);
//         }
//     }
// });

export const pinboardShareLink = createAsyncThunk("pinboardShareLink", async (pinboardId, { rejectWithValue }) => {
    try {
        const response = await axiosInstance.post(`/api/neighbor_pinboard/pinboard/${pinboardId}/shareable-link/`);
        return response.data;
    }
    catch (error) {
        console.error("Error:", error);
        return rejectWithValue(error.response ? error.response.data : error.message);
    }
});

export const NeighborhoodPinboardSlice = createSlice({
    name: "NeighborhoodPinboardSlice",
    initialState: {
        pinboardData: [],
        loading: false,
        loadingMore: false,
        currentPage: 1,
        hasMore: false,
        next: null,
        previous: null,
        error: null,
    },
    reducers: {
        resetSavedPinboard: (state) => {
            state.pinboardData = [];
            state.currentPage = 1;
            state.hasMore = false;
            state.next = null;
            state.previous = null;
            state.error = null;
        },
    },
    extraReducers: (builder) => {
        // postToPinboard
        builder.addCase(postToPinboard.pending, (state) => {
            state.loading = true;
        });
        builder.addCase(postToPinboard.fulfilled, (state, action) => {
            state.loading = false;
            state.pinboardData = action.payload;
        });
        builder.addCase(postToPinboard.rejected, (state, action) => {
            state.loading = false;
            state.error = action.payload;
        });

        // getAllPinboard
        builder.addCase(getAllPinboard.pending, (state) => {
            state.loading = true;
        });
        builder.addCase(getAllPinboard.fulfilled, (state, action) => {
            state.loading = false;
            state.pinboardData = action.payload?.results || [];
            state.next = action.payload?.next;
            state.previous = action.payload?.previous;
            state.hasMore = !!action.payload?.next;
            state.currentPage = action.payload?.page || 1;
            // state.pinboardData = action.payload || [];
        });
        builder.addCase(getAllPinboard.rejected, (state, action) => {
            state.loading = false;
            state.error = action.payload;
        });

        // getLoginUserAllPinboard
        builder.addCase(getLoginUserAllPinboard.pending, (state) => {
            state.loading = true;
            state.error = null;
        });
        builder.addCase(getLoginUserAllPinboard.fulfilled, (state, action) => {
            state.loading = false;
            state.pinboardData = action.payload?.results || [];
            state.next = action.payload?.next;
            state.previous = action.payload?.previous;
            state.hasMore = !!action.payload?.next;
            state.currentPage = action.payload?.page || 1;
        });
        builder.addCase(getLoginUserAllPinboard.rejected, (state, action) => {
            state.loading = false;
            state.error = action.payload;
        });

        // loadMoreUserPinboard
        builder.addCase(loadMoreUserPinboard.pending, (state) => {
            state.loadingMore = true;
            state.error = null;
        });
        builder.addCase(loadMoreUserPinboard.fulfilled, (state, action) => {
            state.loadingMore = false;
            const newResults = action.payload?.results || [];
            // Append new results to existing ones (avoid duplicates)
            const existingIds = new Set(state.pinboardData.map(item => item.id));
            const uniqueNewResults = newResults.filter(item => !existingIds.has(item.id));
            state.pinboardData = [...state.pinboardData, ...uniqueNewResults];
            state.next = action.payload?.next;
            state.previous = action.payload?.previous;
            state.hasMore = !!action.payload?.next;
            state.currentPage = action.payload?.page || state.currentPage + 1;
        });
        builder.addCase(loadMoreUserPinboard.rejected, (state, action) => {
            state.loadingMore = false;
            state.error = action.payload;
        });

        // getSavedPinboard (initial load)
        builder.addCase(getSavedPinboard.pending, (state) => {
            state.loading = true;
            state.error = null;
        });
        builder.addCase(getSavedPinboard.fulfilled, (state, action) => {
            state.loading = false;
            state.pinboardData = action.payload?.results || [];
            state.next = action.payload?.next;
            state.previous = action.payload?.previous;
            state.hasMore = !!action.payload?.next;
            state.currentPage = action.payload?.page || 1;
        });
        builder.addCase(getSavedPinboard.rejected, (state, action) => {
            state.loading = false;
            state.error = action.payload;
        });

        // loadMoreSavedPinboard
        builder.addCase(loadMoreSavedPinboard.pending, (state) => {
            state.loadingMore = true;
            state.error = null;
        });
        builder.addCase(loadMoreSavedPinboard.fulfilled, (state, action) => {
            state.loadingMore = false;
            const newResults = action.payload?.results || [];
            // Append new results to existing ones (avoid duplicates)
            const existingIds = new Set(state.pinboardData.map(item => item.id));
            const uniqueNewResults = newResults.filter(item => !existingIds.has(item.id));
            state.pinboardData = [...state.pinboardData, ...uniqueNewResults];
            state.next = action.payload?.next;
            state.previous = action.payload?.previous;
            state.hasMore = !!action.payload?.next;
            state.currentPage = action.payload?.page || state.currentPage + 1;
        });
        builder.addCase(loadMoreSavedPinboard.rejected, (state, action) => {
            state.loadingMore = false;
            state.error = action.payload;
        });

        // getPinboardById
        builder.addCase(getPinboardById.pending, (state) => {
            state.loading = true;
        });
        builder.addCase(getPinboardById.fulfilled, (state, action) => {
            state.loading = false;
            state.pinboardData = action.payload;
        });
        builder.addCase(getPinboardById.rejected, (state, action) => {
            state.loading = false;
            state.error = action.payload;
        });

        // updatePinboardById
        builder.addCase(updatePinboardById.pending, (state) => {
            state.loading = true;
        });
        builder.addCase(updatePinboardById.fulfilled, (state, action) => {
            state.loading = false;
            state.pinboardData = action.payload;
        });
        builder.addCase(updatePinboardById.rejected, (state, action) => {
            state.loading = false;
            state.error = action.payload;
        });

        // deletePinboard
        builder.addCase(deletePinboard.pending, (state) => {
            state.loading = true;
        });
        builder.addCase(deletePinboard.fulfilled, (state, action) => {
            state.loading = false;
            // Filter out the deleted item from the array
            if (Array.isArray(state.pinboardData)) {
                state.pinboardData = state.pinboardData?.filter(item => item.id !== action.payload.id);
            }
        });
        builder.addCase(deletePinboard.rejected, (state, action) => {
            state.loading = false;
            state.error = action.payload;
        });

        // likePinboard
        // builder.addCase(likePinboard.pending, (state) => {
        //     state.loading = true;
        // });
        // builder.addCase(likePinboard.fulfilled, (state, action) => {
        //     state.loading = false;
        //     // Update the pinboardData with the new like status
        //     const index = state.pinboardData.findIndex(item => item.id === action.payload.id);
        //     if (index !== -1) {
        //         state.pinboardData[index] = action.payload;
        //     }
        // });
        // builder.addCase(likePinboard.rejected, (state, action) => {
        //     state.loading = false;
        //     state.error = action.payload;
        // });

        // savePinboard
        // builder.addCase(savePinboard.pending, (state) => {
        //     state.loading = true;
        // });
        // builder.addCase(savePinboard.fulfilled, (state, action) => {
        //     state.loading = false;
        //     // Update the pinboardData with the new save status
        //     const index = state.pinboardData.findIndex(item => item.id === action.payload.id);
        //     if (index !== -1) {
        //         state.pinboardData[index] = action.payload;
        //     }
        // });
        // builder.addCase(savePinboard.rejected, (state, action) => {
        //     state.loading = false;
        //     state.error = action.payload;
        // });
    },
});

export const { resetSavedPinboard } = NeighborhoodPinboardSlice.actions;
export default NeighborhoodPinboardSlice.reducer;